import { render, staticRenderFns } from "./confirmPayment.vue?vue&type=template&id=1c2d2e8b&scoped=true"
import script from "./confirmPayment.vue?vue&type=script&lang=js"
export * from "./confirmPayment.vue?vue&type=script&lang=js"
import style0 from "./confirmPayment.vue?vue&type=style&index=0&id=1c2d2e8b&prod&scoped=true&lang=css"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "1c2d2e8b",
  null
  
)

export default component.exports